<template>
  <div class="card pa-0">
    <span v-html="$t(`${namespace}.text`)" /><br>
    {{ $t(`${namespace}.tooltip`) }}<br>
    {{ $t(`${namespace}.buttonLabel`) }}
  </div>
</template>

<script>
export default {
  name: 'RegistersWithoutCellPhone',
  data () {
    return {
      namespace: 'Components.RegistersWithoutCellPhone'
    }
  }
}
</script>
